import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'

export type AreasDefaultStylesParams = {
  areasDefaultTitleFont: StyleParamType.Font
  areasDefaultTitleColor: StyleParamType.Color
  areasDefaultDescriptionFont: StyleParamType.Font
  areasDefaultDescriptionColor: StyleParamType.Color
  areasDefaultFillOpacityColor: StyleParamType.Color
  areasDefaultBorderOpacityColor: StyleParamType.Color
  areasDefaultBorderWidth: StyleParamType.Number
  areasDefaultCornerRadius: StyleParamType.Number
}

export const areasDefaultStylesParams = createStylesParams<AreasDefaultStylesParams>({
  areasDefaultTitleFont: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        size: params.isMobile ? 14 : 16,
        style: {
          bold: true,
          underline: false,
          italic: false,
        },
      })(params),
  },
  areasDefaultTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  areasDefaultDescriptionFont: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: wixFontParam('Body-M', {size: 14}),
  },
  areasDefaultDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  areasDefaultFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  areasDefaultBorderOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.6),
  },
  areasDefaultBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  areasDefaultCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
})

export type AreasHoverStylesParams = {
  areasHoverTitleFont: StyleParamType.Font
  areasHoverTitleColor: StyleParamType.Color
  areasHoverDescriptionFont: StyleParamType.Font
  areasHoverDescriptionColor: StyleParamType.Color
  areasHoverFillOpacityColor: StyleParamType.Color
  areasHoverBorderOpacityColor: StyleParamType.Color
  areasHoverBorderWidth: StyleParamType.Number
  areasHoverCornerRadius: StyleParamType.Number
}

export const areasHoverStylesParams = createStylesParams<AreasHoverStylesParams>({
  areasHoverTitleFont: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        size: params.isMobile ? 14 : 16,
      })(params),
  },
  areasHoverTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  areasHoverDescriptionFont: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: wixFontParam('Body-M', {size: 14}),
  },
  areasHoverDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  areasHoverFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  areasHoverBorderOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  areasHoverBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  areasHoverCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
})

export type AreasSelectedStylesParams = {
  areasSelectedTitleFont: StyleParamType.Font
  areasSelectedTitleColor: StyleParamType.Color
  areasSelectedDescriptionFont: StyleParamType.Font
  areasSelectedDescriptionColor: StyleParamType.Color
  areasSelectedFillOpacityColor: StyleParamType.Color
  areasSelectedBorderOpacityColor: StyleParamType.Color
  areasSelectedBorderWidth: StyleParamType.Number
  areasSelectedCornerRadius: StyleParamType.Number
}

export const areasSelectedStylesParams = createStylesParams<AreasSelectedStylesParams>({
  areasSelectedTitleFont: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        size: params.isMobile ? 14 : 16,
      })(params),
  },
  areasSelectedTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  areasSelectedDescriptionFont: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: wixFontParam('Body-M', {size: 14}),
  },
  areasSelectedDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  areasSelectedFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 0.1),
  },
  areasSelectedBorderOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  areasSelectedBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  areasSelectedCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
})
